import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { connect } from "react-redux";

import ChildPanel from "./partials/child-panel/ChildPanel";

import Router from "router/router";
import * as Api from "api/api";
import * as css from "./css/search-goods-category";
import * as SearchAction from "store/search/action";

function SearchGoodsCategory(props) {
  const { className, app, searchAction } = props;
  const { goodsCategoryList } = app;
  let history = useHistory();

  const [childCategoryList, setChildCategoryList] = useState([]);
  const [showChildPanel, setShowChildPanel] = useState(false);
  const [currentHoverCategoryId, setCurrentHoverCategoryId] = useState(-1);
  const [currentCategoryId, setCurrentCategoryId] = useState(-1);
  const [showBigContainer, setShowBigContainer] = useState(false);

  function closePanel() {
    setShowChildPanel(false);
    setShowBigContainer(false);
  }

  function onSelect() {
    closePanel();
    // searchAction.setSelectedCategoryList([]);
  }

  function toSearch({
    categoryId,
    optId,
    categoryName,
    categorySelf,
    parentId,
    level,
    isSelect,
  }) {
    onSelect();
    let search = new URLSearchParams();
    if (categoryName) {
      search.append("parentCategoryId", parentId);
      search.append("categoryId", categoryId);
      search.append("categoryOptId", optId);
      search.append("categoryName", categoryName);
      search.append("categorySelf", categorySelf);
      search.append("level", level);
      search.append("isSelect", isSelect);
      search.append("resetCategory", true);
    }
    history.push({
      pathname: Router.Search.path,
      search: search.toString(),
    });
  }

  async function fetchChildrenCategory(parent) {
    let {
      id: parentId,
      optId: parentOptId,
      name: parentName,
      isSelf,
      hasSelf,
      icon,
      iconActive,
      isSelect,
    } = parent;

    let childList = [];

    if (isSelf) {
      let { list } = await Api.allChildGoodsCategoryList();
      if (list.length === 0) {
        list.push({
          id: parentOptId,
          name: parentName,
          isSelf,
          hasSelf,
        });
      } else {
        list = list.map((item) => {
          return {
            ...item,
            hasSelf,
          };
        });
      }
      childList.push(...list);
    } else {
      const { list } = await Api.pddGoodsCategoryListByParentId({
        parentId,
        parentOptId
      });
      if (list.length === 0) {
        list.push({
          id: parentOptId,
          name: parentName,
          isSelf,
        });
      }
      childList.push(...list);
    }

    setChildCategoryList(childList);
  }

  function renderCategoryList() {
    return goodsCategoryList.map((item, i) => {
      let {
        id,
        optId,
        parentId,
        name,
        isSelf,
        icon,
        iconActive,
        level,
        isSelect,
      } = item;
      //   如果是平台自营
      if (id === 0) {
        icon = require("./img/self-category.jpg");
        iconActive = require("./img/self-category-active.jpg");
      }

      const onMouseEnter = async () => {
        setShowChildPanel(true);

        setCurrentHoverCategoryId(id);
        setCurrentCategoryId(id);
        fetchChildrenCategory({ ...item });
      };

      const onMouseLeave = () => {
        setShowChildPanel(false);
        setCurrentHoverCategoryId(-1);
      };

      return (
        <css.CategoryItemWrapper
          key={id}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={() => {
            toSearch({
              categoryId: id,
              optId,
              categoryName: name,
              categorySelf: isSelf,
              parentId,
              level,
              isSelect,
            });
          }}
        >
          {currentHoverCategoryId === id ? (
            <css.CategoryItemHover>
              <img src={iconActive} alt="" className="icon" />
              {name}
              <div className="bg-img-wrapper">
                <img
                  src={require("./img/hover-bg.png")}
                  alt=""
                  className="bg-img"
                />
              </div>
            </css.CategoryItemHover>
          ) : (
            <css.CategoryItem>
              <img src={icon} alt="" className="icon" />
              {name}
              <img
                src={require("./img/arrow-right.png")}
                alt=""
                className="more"
              />
            </css.CategoryItem>
          )}
        </css.CategoryItemWrapper>
      );
    });
  }

  return (
    <css.GoodsCategory className={`${className} searchGoodsCategory`}>
      {showBigContainer ? (
        <css.BigContainer
          onMouseEnter={() => {
            setShowBigContainer(true);
          }}
          onMouseLeave={() => {
            setShowBigContainer(false);
          }}
        >
          {/* bg */}
          <div className="bg-img-wrapper">
            <img src={require("./img/bg.png")} alt="" className="bg-img" />
          </div>
          <css.CategoryContainer>
            <css.CategoryItem className="all">
              所有分类
              <img
                src={require("./img/all-category-icon.png")}
                alt=""
                className="icon"
              />
            </css.CategoryItem>
            {renderCategoryList()}
          </css.CategoryContainer>
          {/* child panel */}

          {showChildPanel && (
            <css.ChildPanel
              // className={`${showChildPanel ? 'show' : ''}`}
              as={ChildPanel}
              childList={childCategoryList}
              onSelect={() => {
                onSelect();
              }}
              onMouseEnter={(i) => {
                setShowChildPanel(true);
                setCurrentHoverCategoryId(currentCategoryId);
              }}
              onMouseLeave={() => {
                setShowChildPanel(false);
                setCurrentHoverCategoryId(-1);
              }}
            />
          )}
        </css.BigContainer>
      ) : (
        <css.SmallContainer
          onMouseEnter={() => {
            setShowBigContainer(true);
          }}
          onMouseLeave={() => {
            setShowBigContainer(false);
          }}
        >
          <div className="bg" />
          <css.CategoryItem className="all">
            所有分类
            <img
              src={require("./img/all-category-icon.png")}
              alt=""
              className="icon"
            />
          </css.CategoryItem>
        </css.SmallContainer>
      )}
    </css.GoodsCategory>
  );
}

export default connect(
  (state) => {
    const { app } = state;

    return { app };
  },
  (f) => ({
    searchAction: {
      setSelectedCategoryList() {
        f(SearchAction.setSelectedCategoryList(...arguments));
      },
    },
  })
)(SearchGoodsCategory);
